import * as types from "./brasao.actionsType";
import Immutable from "seamless-immutable";

const initialState = Immutable({
  UrlBrasao: undefined
});

export default function reduce(state = initialState, action = {}) {
  switch (action.type) {
    case types.SET_BRASAO:
      return state.merge({
        UrlBrasao: action.payload
      });
    default:
      return state;
  }
}
